<div class="title-wrapper">
  <div class="mat-headline-5">{{ "ONSIP_I18N.VOICEMAIL_MANAGER" | translate }}</div>
  <p class="mat-body-2 subtitle">
    {{ "ONSIP_I18N.CHECK_VOICEMAIL_MESSAGES_OR_MANAGE_A_VOICEMAIL_BOX" | translate }}
  </p>
</div>
<onsip-loading-container [deferCond]="isDataObtained$">
  @if (voicemailManagement$ | async) { @if ((voicePanel$ | async) === 'view') {
  <onsip-voicemail-manager-view
    [voicemailManagement]="(voicemailManagement$ | async)!"
    (editPanel)="togglePanel('edit')"
  ></onsip-voicemail-manager-view>
  } @if ((voicePanel$ | async) === 'edit') {
  <onsip-voicemail-manager-edit
    [voicemailManagement]="(voicemailManagement$ | async)!"
    (editPanel)="togglePanel('view')"
  ></onsip-voicemail-manager-edit>
  } }
  <div class="mat-body-2 contact-support">
    {{ "ONSIP_I18N.NEED_HELP_CONTACT_OUR" | translate }}
    <a class="support-link" [routerLink]="[views.CONTACT_SUPPORT]">
      {{ "ONSIP_I18N.SUPPORT_TEAM" | translate }}
    </a>
  </div>
</onsip-loading-container>
